<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <div v-if="shouldShowAdvanceTransfer" class="apply-button text-end mx-6">
                <v-btn v-if="(clientVersionId == 'DEG' && ((categoryId != 1 && statusId == 5) || categoryId == 1 )) || clientVersionId != 'DEG'"
                    text class="p-0 btn-link" @click="multiTransferFormDialog=true">
                    {{ $t("res_Label_AdvancedTransfer") }}
                </v-btn>
            </div>
            <label v-if="numberOfAttachmentsRemainingToUpload !== 0" style="color: red !important; font-style: italic;">
                {{ $t('res_Msgs_transferMoreAttachmentError').replace('{0}', numberOfAttachmentsRemainingToUpload) }}
            </label>
            <div class="mb-3-rem" v-if="sign && this.isDelegatedDocumentTransferProp == true">
                <label class="mb-2">{{ $t("res_Label_OnBehalfOf") }}</label>
                <v-checkbox v-model="onBehalfOf" color="#00ae8d" class="mt-0"></v-checkbox>
            </div>
            <div class="mb-3-rem" v-if="!canSignWithoutPinCode && sign">
                <v-label>{{ $t("res_Label_PinValue") }}</v-label>
                <div class="d-flex gap-2">
                    <v-text-field :readonly="pinValidate" @keyup.enter="ValidatePin" v-model="pinCode" solo
                        type="password" :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNew ? 'text' : 'password'" 
                        @click:append="showNew = !showNew"></v-text-field>
                        
                    <v-btn class="small icon m-auto shadow-sm border p-2" style="cursor: pointer !important;" :disabled="pinValidate" @click="ValidatePin">
                        <v-icon class="custom-icon">mdi-check-ring</v-icon>
                    </v-btn>
                </div>
            </div>
            <div class="mb-3-rem" v-if="showSignaturesList == true && enableUserToSelectSigner == true && sign && (!constants.signUsingUAEPassEnabled && !constants.SignUsingDocusignEnabled)">
               <v-label>{{ $t("res_Label_SelectSigner") }}</v-label> 
                <div class="d-flex gap-2">
                    <v-select :disabled="signerList == null || signerList.length <= 1" v-model="selectedSigner" 
                        :items="signerList" item-text="text" item-value="id" label="" solo return-object></v-select>  
                </div>
            </div>
            <div class="mb-3-rem" v-if="sign && enableUserMultipleSignatures == true">
                <v-label>{{ $t("res_Label_Signature") }}</v-label> 
                <v-select :disabled="!pinValidate || (userSignatures == null || userSignatures.length <= 1)" v-model="userSignature" :items="userSignatures" item-text="text" item-value="id" label="" solo return-object></v-select>  
            </div>

            <div class="mb-3-rem">
                <v-chip
                    class="ma-2 success"
                    v-for="item in transferFavoriteList"
                    :key="item.id"
                    v-if="item.active !== 'False'"
                    @click="selectFavoriteUser(item)"
                >
                    <v-icon v-if="item.userId != 0" :style="{ color: (item.active == 'False') ? 'red' : 'green'}" class="m-2">mdi-account</v-icon>
                    <v-icon v-else :style="{ color: (item.active == 'False') ? 'red' : 'green'}" class="m-2">mdi-folder-multiple-outline</v-icon>
                    {{ item.name }}
                </v-chip>
            </div>

            <div class="mb-3-rem" v-if="localTransferToMulti.length == 0 && !forwardCC" @click="focusField = 1">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true"  :class="{ 'green-border': focusField === 1 }"
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="false" :selectedStructureUser="localTransferTo"
                    @structureUserSelectChanged="transferToSelectedChange"
                    :disabled="(!pinValidate || disableRecipient)" :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                    :hideStructureWithDisableTransfer="!ShowStructuresInTransferForm" :loadOnlyInScopeInternalStrucutres="ShowStructuresInTransferForm"
                    :ignoreHideInTransfer="false" >
                </StructureUserSelector>
                <v-banner v-if="!doesStructureHaveAReciever" single-line outlined style="background-color: #f9f9f9; margin-top: .5rem;">
                    <v-icon slot="icon" color="warning" size="25">mdi-alert</v-icon>
                    <span>{{ $t("res_Msgs_StructureDoesNotHaveAReceiver") }}</span>
                </v-banner>
            </div>       
            <div class="mb-3-rem" v-if="localTransferToMulti.length > 0" @click="focusField = 2">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true" :showExternalStructures="false"
                    :excludeSelf="true" :isMultiple="true" :class="{ 'green-border': focusField === 2 }"
                    :selectedStructureUsersList="localTransferToMulti"
                    @structureUserSelectChanged="transferToMultipleSelectedChange"
                    :disabled="(!pinValidate || disableRecipient)&&(!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled)" :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                    :ignoreHideInTransfer="false">
                </StructureUserSelector>
            </div>
            <div class="mb-3-rem" v-if="Forwarded && Forwarded.length > 0">
                <v-list>
                    <v-list-item v-for="item in Forwarded" :key="item">
                        <v-list-item-content>
                            <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>

            <div class="mb-3-rem" @click="focusField = 3">
                <v-label>{{ $t("res_Label_CC") }}</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true" :class="{ 'green-border': focusField === 3 }"
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="true" :selectedStructureUsersList="localTransferCC"
                    @structureUserSelectChanged="ccSelectedChange"
                    :disabled="!pinValidate && (!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled)"
                    :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                    :ignoreHideInTransfer="false">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem">
                <div class="d-flex gap-4">
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_Purpose") }} *</v-label>
                        <multiselect :disabled="(!pinValidate || forwardCC || rejected) || (!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled)" class="light-bg add-arrow" v-model="purpose"
                            label="name" track-by="id" open-direction="bottom" :options="purpose_items" 
                            :searchable="true" :loading="loading" :internal-search="true" :clear-on-select="false"
                            :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                            :hide-selected="false" :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')">
                        </multiselect>
                    </div>
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_DueDate") }}</v-label>
                        <v-menu content-class="p-0" v-model="transfer_date_menu" :close-on-content-click="false"
                            transition="scale-transition" offset-y left min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :readonly="(!pinValidate) && (!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled)" :value="utils.dateFormat(dueDate)" :label="$t('res_Label_SelectDate')"
                                    v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="language" :readonly="!pinValidate" v-model="dueDate" @input="transfer_date_menu = false"
                                :min="nowDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </div>

            <div class="pt-2" style="margin-bottom: 23px; line-height: 0"> 
                <v-label>{{ $t("res_Label_Instruction") }} {{( this.noteIsMandatory ? '*' : '' )}}</v-label>
                <textarea class="text-area" :readonly="!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled" style="height:100px" v-model="note"></textarea>
            </div>
            <div class="mb-3-rem" v-if="!forwardCC">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-checkbox :label="$t('res_Label_NeedFollowUp')" class="m-0 p-0" v-model="followup"></v-checkbox>
                    </div>
                    <div class="d-flex align-center" v-if="canSendSecretTransfer && !forwardCC">
                        <v-checkbox :label="$t('res_Label_SecretForward')" :readonly="!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled"  class="m-0 p-0" 
                        v-model="secretForward"> </v-checkbox>
                    </div>
                    <div class="d-flex align-center">
                        <v-checkbox :label="$t('res_Label_IsSecretNote')" :readonly="!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled" class="m-0 p-0" v-model="isSecretNote"></v-checkbox>
                    </div>
                </div>
            </div> 
        </div>

        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="cancelDialog">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            <v-btn v-if="!sign" class="primary flex-1" :disabled="(!pinValidate || numberOfAttachmentsRemainingToUpload !== 0) && (!constants.signUsingUAEPassEnabled && !constants.signUsingDocusignEnabled)"
                @click="Send">{{ $t('res_ButtonText_Continue') }}
            </v-btn>
            <v-btn v-if="sign && !rejected" class="light-success  flex-1" style="color: #009639 !important;"   
                    :disabled="(!pinValidate || numberOfAttachmentsRemainingToUpload !== 0) || (enableUserMultipleSignatures == true && (userSignatures == null || userSignatures.length <= 0))" @click="Send">
                    <v-icon class="custom-icon" >mdi-check-ring</v-icon>&nbsp;{{ $t("res_ButtonText_SignAndTransfer") }}
            </v-btn>
            <v-btn v-if="sign && rejected" class="danger  flex-1"  style="color: #ea0000 !important;"    :disabled="!pinValidate || numberOfAttachmentsRemainingToUpload !== 0" @click="Send">
                <v-icon class="custom-icon">mdi-close-circle</v-icon>{{ $t("res_ButtonText_Reject") }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog" :allowUAEPASSSignature="allowUAEPASSSignature"
                                              :allowESignature="allowESignature"
                                              @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                                              @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                                              @closeSignFormDialog="closeSignFormDialog"
                                              :isSignAndSend="isSignAndSend"
                                              :isUAEPassEnabledForTemplate="isUAEPassEnabledForTemplate"
                                              :isEsealEnabledForTemplate="isEsealEnabledForTemplate"
                                              @uaeDocumentSigned="transfer" />
                    </div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title>
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <Sign :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                            :isSignAndSend="isSignAndSend"
                            @uaeDocumentSigned="transfer" :onBehalfOfChecked="onBehalfOf" :isDelegatedDocumentSignProp="this.isDelegatedDocumentTransferProp"
                            @closeSignFormDialog="closeSignFormDialog" :purpose="this.purpose"/>
                    </div>
                </v-card>
            </v-dialog>
        <v-dialog v-model="multiTransferFormDialog" content-class="dialog with-fixed-actions bg-white" fullscreen scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_Label_AdvancedTransfer") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="multiTransferFormDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
                <v-banner single-line outlined style="background-color: #f9f9f9;">
                    <v-icon slot="icon" color="warning" size="30">mdi-alert</v-icon>
                    <span style="font-size: 1rem;">{{ $t("res_Msgs_AdvancedTransferWarningMessage") }}</span>
                </v-banner>
                <MultiTransferForm @closeMultiTransferForm="multiTransferFormDialog=false" @closeTransferDialog="closeMultiTransferForm" 
                :documentId="documentId" :transferId="transferId" 
                :purpose_items="purpose_items" :favoriteTransfers="this.transferFavoriteList"></MultiTransferForm>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import { McWysiwyg } from '@mycure/vue-wysiwyg'
import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
import { getTransferPurposes } from '@/store/modules/lookups.js'
import debounce from "lodash.debounce"
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import MultiTransferForm from '@/components/MultiTransferForm.vue'
import Sign from '@/components/Sign.vue'
import * as docActions from '@/assets/js/documentActions.js'
import CryptoJS from 'crypto-js';
export default {
    name: 'TransferForm',
    components: { Multiselect, SignSelectSignMethod, Sign, McWysiwyg, StructureUserSelector, MultiTransferForm },
    data() {
        return {
            enableUserMultipleSignatures: constants.enableUserMultipleSignatures,
            userSignature: null,
            userSignatures: [{id:0 , text: ''}],
            language: '',
            dueDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
            loading: false,
            structures: [],
            transferDate: '',
            CCstructures: [],
            purpose_items: [],
            Forwarded: [],
            pinCode: '',
            pinValidate: !this.sign || this.canSignWithoutPinCode,
            transfer_date_menu: false,
            note: '',
            followup: false,
            secretForward: false,
            nowDate: new Date().toISOString().slice(0, 10),
            canSendSecretTransfer: constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.SecretTransfer.key),
            numberOfAttachmentsRemainingToUpload: 0,
            debouncedHandler1: null,
            debouncedHandler2: null,
            utils: utils,
            constants:constants,
            multiTransferFormDialog: false,
            disableAdvancedTransfersBeforeIsSigned: window.disableAdvancedTransfersBeforeIsSigned,
            ShowStructuresInTransferForm:window.ShowStructuresInTransferForm,
            isSecretNote: false,
            openSelectSignMethod:false,
            signFormDialog:false,
            isSignAndSend:false,
            selectSignMethodFormDialog:false,
            isUAEPassEnabledForTemplate: false,
            isEsealEnabledForTemplate: false,
            allowedAdvancedTransferFormTypes: ['Forward', 'ForwardCc'],
            doesStructureHaveAReciever: true,
            disableAdvancedTransferNew: true,
            hasPurposeWatched: false,
            signerList: [],
            showSignaturesList: false,
            enableUserToSelectSigner: false,
            selectedSigner: {id:0 , text: ''},
            onBehalfOf: false,
            showNew: false,
            transferFavoriteList: [],
            userId: JSON.parse(sessionStorage.getItem("user")).profile.Id,
            structureId: JSON.parse(sessionStorage.getItem("user")).profile.StructureId,
            focusField: 0,
            localTransferTo: null,
            localTransferToMulti: [],
            localTransferCC: [],
            allowESignature: false,
            allowUAEPASSSignature: false
        }
    },
    props:
    {
        forwardCC: {type: Boolean, dafault: false },
        workflowId: { type: Number, default: 0 },
        rejected: { type: Boolean, default: false },
        disableRecipient: { type: Boolean, default: false },
        documentId: { type: [String, Number], default: '0' },
        transferId: { type: [String, Number], default: '0' },
        transferTo: { type: Object, default: () => ({}) },
        transferToMulti: { type: Array, default: () => [] },
        transferCC: { type: Array, default: () => [] },
        sign: { type: Boolean, default: false },
        successMessage: { type: String, default: 'res_Msgs_DocumentSignedAndSent' },
        purpose: { type: Object, default: {} },
        delegationId: { type: Number, default: 0 },
        transferFormDialog: { type: Boolean, default: false },
        checkForAttachmentsUploadMultiApproval: { type: Boolean, default: false },
        defaultDueDate: { type: String, default: '' },
        disableAdvancedTransfer:{ type: Boolean, default: false },
        transferFormType: { type: String, default: 'Transfer' }, 
        noteIsMandatory:{ type: Boolean, default: false }, 
        enableRecipientsMultiPages: {type: String, default: ""},
        canSignWithoutPinCode: { type: Boolean, default: false },
        categoryId: { type: Number, default: 0 },
        clientVersionId : { type: String, default: '' },
        statusId: { type: Number, default: 0 },
        propertyBag: { type: Object },
        isDelegatedDocumentTransferProp: { type: Boolean, required: false, default: false }
    },
    beforeMount() 
    {
        this.debouncedHandler1 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.structures = res.data)
                .catch(err => console.log(err));
        }, 200);

        this.debouncedHandler2 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.CCstructures = res.data)
                .catch(err => console.log(err));
        }, 200);
    },
    methods:
    {
        resolvedDelegationId()
        {
            return this.propertyBag?.delegationId ?? this.delegationId ?? 0
        },
        selectFavoriteUser(item)
        {
            // 1 -- To Single Field, 2 -- To Multi Field, 3 -- CCed Field
            if (this.focusField === 1 && !this.disableRecipient) {
                this.localTransferTo =
                    item.userId != 0
                        ? {
                            color: "",
                            external: false,
                            id: item.userId + "-" + item.structureId,
                            name: item.name,
                            isUser: true
                        }
                        : {
                            color: "",
                            external: false,
                            id: item.structureId,
                            name: item.name,
                            isUser: false
                        }
            }
            else if (this.focusField === 2 && !this.disableRecipient) {

                const exists = this.localTransferToMulti.some(x => x.id === (item.userId + "-" + item.structureId));
                if (!exists) {
                        this.localTransferToMulti.push(
                            item.userId != 0
                                ? {
                                    color: "",
                                    external: false,
                                    id: item.userId + "-" + item.structureId,
                                    name: item.name,
                                    isUser: true
                                }
                                : {
                                    color: "",
                                    external: false,
                                    id: item.structureId,
                                    name: item.name,
                                    isUser: false
                                }
                        );
                }
            }
            else if (this.focusField === 3) {
                const exists = this.localTransferCC.some(x => x.id === (item.userId + "-" + item.structureId));
                if (!exists) {
                    this.localTransferCC.push(
                        item.userId != 0
                            ? {
                                color: "",
                                external: false,
                                id: item.userId + "-" + item.structureId,
                                name: item.name,
                                isUser: true
                            }
                            : {
                                color: "",
                                external: false,
                                id: item.structureId,
                                name: item.name,
                                isUser: false
                            }
                    );
                }
            }
            else
            {
                if((![1, 2].includes(this.focusField) && !this.disableRecipient) || this.focusField==0){
                    window.showAlert(this.$t('res_Msgs_FocusFieldAlert'), 'warning');
                }else{
                    window.showAlert(this.$t('res_Msgs_NOtAllowedAddFavoriteUserToFocusField'), 'warning');
                }
            }
        },
        async GetUserSignatures(documentId) { 
                try { 
                    const response =
                        await axios.get(`${constants.baseApiUrl}Admin/GetUserSignaturesForSign?lang=${localStorage.getItem('lang')}&documentId=${documentId}`);
                    if (response.data) {  
                            this.userSignatures = response.data;
                            if(this.userSignatures.length == 1)
                            {
                                this.userSignature = this.userSignatures[0];
                            }
                    }
                    } catch (error) {
                        console.error(error);
                    }
		},
        closeSignFormDialog() 
        {
            this.signFormDialog = false
        },
        closeSelectSignMethodFormDialog() 
        {
            this.selectSignMethodFormDialog = false
        },
        closeSignMethodSelectAndOpenSignWithPin() 
        {
            this.selectSignMethodFormDialog = false
            this.signFormDialog = true
        },
        openSelectSignMethodDialog()
        {
            this.isSignAndSend = true;
            
            if(this.allowESignature && !this.allowUAEPASSSignature)
            {
                this.closeSignMethodSelectAndOpenSignWithPin();
            }
            else
            {
                this.selectSignMethodFormDialog = true
            }
        },
        openMultiSelectCtrl(id) 
        {
            if (id === 1) this.$refs.multiselect1.activate()
        },
        ValidatePin() 
        {
            if (this.pinCode == '') 
            {
                window.showAlert('res_Msgs_EnterPin', 'warning')
            }
            else
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckHasValidPin?pinValue='
                    + encodeURIComponent(this.pinCode) + '&canSignWithoutPinCode=' + this.canSignWithoutPinCode)
                        .then(res =>
                        {
                            if (res.data.item1 == false)
                            {
                                window.hideLoading()
                                if (res.data.item2 == 'SignaturePinNotSet')
                                {
                                    window.showAlert('res_Msgs_PinNotSet', 'warning')
                                }
                                else
                                    window.showAlert('res_Msgs_InvalidPin', 'error')
                            }
                            else
                            { 
                                 axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.resolvedDelegationId())
                                    .then(res =>
                                    { 
                                        if (res.data.item1 == false)
                                        {
                                            window.hideLoading()
                                             window.showAlert('res_Msgs_NoDefaultSignature', 'warning')
                                        }
                                        else
                                        {
                                            this.pinValidate = true;
                                            var encryptedPinValue = this.encryptParameter(this.pinCode)
                                            sessionStorage.setItem("userPinCode", encryptedPinValue)
                                        }
                                })
                                .catch(error => { console.log(error); window.hideLoading(); })
                        }
                    })
                    .catch(err => window.showAlert(err, 'error'))
                    .finally(() => window.hideLoading())
            }
        },
        removeToItem(itemId) 
        {
            this.localTransferTo = this.localTransferTo.filter(item => item.id !== itemId);
        },
        CapitalizeFirstLetter(str) 
        {
            return utils.CapitalizeFirstLetter(str);
        },
        GetMultiSelectSubHeaderDisplay(options) 
        {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        asyncFindTransferToStructure(query) 
        {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => 
                {
                    this.structures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        asyncFindTransferCCStructure(query) 
        {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => 
                {
                    this.CCstructures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        Send() 
        {
            window.showLoading()

            if (this.noteIsMandatory == true && this.note == '' || this.note == null)
            {
                window.hideLoading()
                window.showAlert('res_Msgs_FillRequired', 'warning')
                return; 
            }

            // if (this.enableUserToSelectSigner && this.showSignaturesList  && this.selectedSigner.id==0)
            // {
            //      window.hideLoading()
            //      window.showAlert('res_Msgs_SelectSignature', 'warning')
            //     return; 
            // }

            if (this.sign && !this.rejected &&(constants.signUsingUAEPassEnabled || constants.signUsingDocusignEnabled))
            {
                
                if ((this.localTransferTo?.id != null && this.localTransferTo.id !== '') ||
                    (this.localTransferToMulti?.length > 1)) 
                {
                    if (this.purpose == null || this.purpose == undefined || this.purpose == '' || this.purpose.id == null || this.purpose.id == undefined || this.purpose.id == '') 
                    { 
                        window.hideLoading()
                        window.showAlert('res_Msgs_FillRequired', 'warning')
                        return;
                    }
                    else
                    {
                        window.hideLoading()
                        this.openSelectSignMethodDialog()
                    }
                }
                else 
                {
                    window.hideLoading()
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }
            }
            else if (this.sign && !this.rejected ) 
            {
                const enableRecipientsMultiPages = this.constants.enableRecipientsMultiPages && (this.enableRecipientsMultiPages == 1 || this.enableRecipientsMultiPages == '1'  || constants.client_version_Id == "DEG")
                axios.post(constants.baseApiUrl + 'Document/SignDocument?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.delegationId+'&impersonatedSignature='+this.onBehalfOf+'&enableRecipientsMultiPages='+enableRecipientsMultiPages+'&selectedSignerId='+selectedSignerId)
                    .then(res => 
                    { 
                        if (res.data.status == false) {
                            if (res.data.message == 'MissingUserSignature') {
                                window.showAlert(this.$t('res_Msgs_MissingDefaultSignature'), 'warning');
                            }
                        }
                        else {
                            this.transfer()
                        }
                       })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            }
            else if (this.rejected && this.sign )
            {
                if (!this.pinValidate)
                {
                    window.hideLoading()
                    window.showAlert('res_Msgs_EnterPin', 'warning')
                    return;
                }
                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/RejectDocument?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.delegationId+'&impersonatedSignature='+this.onBehalfOf+'&enableRecipientsMultiPages='+this.constants.enableRecipientsMultiPages)
                    .then(res => {  
                        this.transfer() 
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            }
            else
            {
                this.transfer()
            }
        },
        closeDialog() 
        {
            this.clearForm()
            this.$emit('closeTransformDialog');
        },
        transfer()
        {
            if (
                (this.localTransferTo?.id != null && this.localTransferTo.id !== '') ||
                (this.localTransferToMulti?.length > 0) ||
                Boolean(this.forwardCC)
            ) 
            {
                if (this.purpose == null || this.purpose == undefined || this.purpose == '' || this.purpose.id == null || this.purpose.id == undefined || this.purpose.id == '') 
                {
                    window.hideLoading()
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }

                var transferTos = [];
               if (this.localTransferTo?.id != null && this.localTransferTo.id !== '') 
                    transferTos.push(this.localTransferTo);
                else
                    transferTos = [...this.localTransferToMulti];

                var transferCCs = [...this.localTransferCC];
                var params = {
                    TransferId: this.transferId,
                    DocumentId: this.documentId,
                    ForwardTo: transferTos,
                    ForwardCC: transferCCs,
                    Purpose: this.purpose.id,
                    DueDate: this.dueDate,
                    Note: this.escapeHTML(this.note),
                    FollowUp: this.followup,
                    SecretForward: this.secretForward,
                    DelegationId: this.delegationId,
                    IsSecretNote: this.isSecretNote,
                    WorkflowId: this.workflowId,
                    IsForwardCC: this.forwardCC
                }

                axios.post(constants.baseApiUrl + 'Transfer/TransferDocument', params)
                    .then(res => 
                    {
                        if (res.data.item1 == 'CantTransfer') 
                        {
                            window.showAlert('res_Msgs_DocumentTransferFailed', 'error')
                            return;
                        }

                        window.showAlert('res_Msgs_DocumentTransferSuccess', 'success')
                        window.hideLoading()
                        this.closeDialog();
                    })
                    .catch(err => console.log(err))
                    .finally(() => window.hideLoading())
            }
            else 
            {
                window.hideLoading()
                window.showAlert('res_Msgs_FillRequired', 'warning')
                return;
            }
        },
        escapeHTML(input)   
        {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };

            return String(input).replace(/[&<>"']/g, function(match) {
                return map[match];
            });
        },
        clearForm() 
        {
            this.note = ''
            this.onBehalfOf = true
            //this.CheckSignatureImpersonation()
            this.dueDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
            this.followup = false
            this.secretForward = false
            this.pinCode = ''
            // this.checkForAttachmentsUploadMultiApproval = false
            this.numberOfAttachmentsRemainingToUpload = 0
            this.isSecretNote = false
            this.disableRecipient=false
            try 
            {
                if (this.defaultDueDate) 
                {
                    const defaultDueDateWithoutTime = utils.formatDateFromString(this.defaultDueDate);
                    const currentDateWithoutTime = new Date();

                    defaultDueDateWithoutTime.setHours(0, 0, 0, 0);
                    currentDateWithoutTime.setHours(0, 0, 0, 0);

                    if (defaultDueDateWithoutTime >= currentDateWithoutTime)
                        this.dueDate = this.defaultDueDate;
                }

                // clearing the wsiwyg editor
                document.getElementById('editor').innerText = ''
                var arrElements = document.all['editor'];
                for (let index = 0; index < arrElements.length; index++) 
                {
                    arrElements[index].innerText = '';
                }
            }
            catch (e) { }
        },
        cancelDialog() 
        {
            this.clearForm()
            this.$emit('cancelCorrespondenceDocument');
        },
        removeItem(itemId) 
        {
            this.localTransferToMulti = this.localTransferToMulti.filter(item => item.id !== itemId);
        },
        transferToMultipleSelectedChange(items) 
        {
            this.localTransferToMulti = items;
        },
        transferToSelectedChange(item)
        {
            if (item == null) {
                this.localTransferTo = null;
                this.doesStructureHaveAReciever = true;
                return;
            }
            this.localTransferTo = item;
            if(!item.isUser)
                this.checkIfStructureHasAReciever(item.id);
            else
                this.doesStructureHaveAReciever = true;
        },
        ccSelectedChange(items)
        {
            this.localTransferCC = items;
        },
        // CheckSignatureImpersonation()
        // {
        //     axios.get(constants.baseApiUrl + 'Delegation/CanImpersonatedSign?delegationId=' + this.delegationId)
        //         .then(res => { this.canSignByImpersonation = res.data
        //             this.SelectedSignAsOption = this.canSignByImpersonation && this.sign && constants.enableImpersonateSignatureInDelegation
        //          })
        //         .catch(err => console.log(err));
        // },
        closeMultiTransferForm()
        {
            this.multiTransferFormDialog = false;
            this.closeDialog();
        },
        onFormLoaded()
        {
            this.clearForm();
            this.purpose_items = getTransferPurposes();

            if(!this.forwardCC)
            {
                this.purpose_items = this.purpose_items.filter(x => x.id != constants.purposesEnum.CCed && x.id != constants.purposesEnum.ApprovedSignManual && x.id != constants.purposesEnum.ForCoordination &&
                    x.id != constants.purposesEnum.NeedFeedback && x.id != constants.purposesEnum.EyesOnly);
            }

            if (this.rejected)
                this.purpose_items = this.purpose_items.filter(x => x.id != constants.purposesEnum.Approved);

            docActions.DoesDocumentHavePendingSignatures(this.documentId, (res) =>
            {
                if (res.item1 == false)
                    this.purpose_items = this.purpose_items.filter(x => x.id != constants.purposesEnum.ForSignature)
                else
                {
                    // res.item2 will be the total number of signatures on the template
                    if (res.item2 != 0)
                    {
                        // res.item3 will be the total signers sofar
                        if (res.item2 == res.item3 || ( res.item2 == (res.item3 + 1) && this.sign))
                        {
                            this.purpose_items = this.purpose_items.filter(x => x.id != constants.purposesEnum.ForSignature)
                        }
                    }
                }     
            })

            this.language = localStorage.getItem('lang')
            if (this.transferFormType == 'Endorse')
            {
                this.disableRecipient = true
                this.canSendSecretTransfer = false
                this.disableAdvancedTransferNew = true
                this.disableAdvancedTransfersBeforeIsSigned = true
            }
            else
            {
                this.disableRecipient = false
                this.canSendSecretTransfer = constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.SecretTransfer.key)
                this.disableAdvancedTransferNew = false
                this.disableAdvancedTransfersBeforeIsSigned = window.disableAdvancedTransfersBeforeIsSigned
            }
        },
        isNullOrUndefined(value)
        {
            return value == null || value == undefined;
        },
        async checkIfStructureHasAReciever(structureId)
        {
            try {
                const response = await axios.get(constants.baseApiUrl + 'Transfer/DoesStructureHaveAReceiver?structureId=' + structureId);
                this.doesStructureHaveAReciever = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async GetUserMultiSignatures(documentId) 
        { 
            try 
            { 
                const response =
                    await axios.get(`${constants.baseApiUrl}Admin/GetUserMultiSignaturesForSign?lang=${localStorage.getItem('lang')}&documentId=0`);
                if (response.data) 
                {  
                    if(response.data.count>1)
                    {
                        this.signerList = response.data.items;
                        if(this.signerList.length == 1)
                        { 
                            this.signerList = this.signerList[0]; 
                        }

                        this.showSignaturesList = true;
                    }
                    else 
                    {
                        this.showSignaturesList = false;
                    }
                }
            }
            catch (error) 
            {
                console.error(error);
            }
         },
        async GetUserMultiSignatures(documentId) 
        { 
            try 
            { 
                    const response =
                        await axios.get(`${constants.baseApiUrl}Admin/GetUserMultiSignaturesForSign?lang=${localStorage.getItem('lang')}&documentId=0`);
                    if (response.data) {  
                        if(response.data.count>1){
                            this.signerList = response.data.items;
                            if(this.signerList.length == 1)
                            { this.signerList = this.signerList[0]; }
                            this.showSignaturesList=true;
                            
                    }else this.showSignaturesList=false;
                }
            }
            catch (error) 
            {
                console.error(error);
            }
        },
        async getUserApplicatinRole() 
        {
            try 
            {
                const response = await axios.get(constants.baseApiUrl + 'User/GetUserApplicationRole');

                const data = response.data;
                if (data && data.name == "Managers") {

                    this.enableUserToSelectSigner = true;
                    this.GetUserMultiSignatures(this.documentId);
                } else {
                    this.enableUserToSelectSigner = false;
                }
            } 
            catch (err) 
            {
                console.error('Error fetching user role:', err);
            }
        },
        encryptParameter(plainText) {
            var keeey = '3'+'e'+'3'+'5'+'e'+'e'+'a'+'4'+'7'+'1'+'7'+'7'+'5'+'1'+'9'+'1';
            var key = CryptoJS.enc.Utf8.parse(keeey);
            var iv = CryptoJS.enc.Utf8.parse(keeey);
        
            var encryptedValue = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(plainText),
                key,
                { keySize: 128 / 8, iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
            );
        
            return encryptedValue.toString();
        },
        decryptParam(cipherText) {
            var keeey = '3'+'e'+'3'+'5'+'e'+'e'+'a'+'4'+'7'+'1'+'7'+'7'+'5'+'1'+'9'+'1';
            var key = CryptoJS.enc.Utf8.parse(keeey);
            var iv = CryptoJS.enc.Utf8.parse(keeey);
        
            var decrypted = CryptoJS.AES.decrypt(cipherText, key, {
              keySize: 128 / 8,
              iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
            });
        
            return decrypted.toString(CryptoJS.enc.Utf8);
        },
        getTransferFavorite() 
        {
            this.transferFavoriteList = [];

            axios.get(constants.baseApiUrl + 'Transfer/GetTransferFavorite?UserId=' + this.userId
                + '&StructureId=' + this.structureId, { headers: constants.headers })
                .then(response => {
                    if (response.data != null && response.data) {
                        response.data.forEach(fav => {
                            var favLstBody = {
                                userId: fav.favUserId,
                                structureId: fav.favStructureId,
                                name: fav.name,
                                active: fav.active
                            }

                            this.transferFavoriteList.push(favLstBody)
                        })
                    }
                })
                .catch(err => console.warn(err))

            this.addTransferFavoriteDialog = true;
        },
        openDefaultSignerMethod()
        {
            axios.post(constants.baseApiUrl + 'StructureUser/GetDefaultSignerMethod', null)
                .then(response => 
                {
                    if (response.data != null)
                    {
                        this.allowESignature = response.data.allowESignature,
                        this.allowUAEPASSSignature = response.data.allowUAEPASSSignature
                    }
                }).catch(err => console.warn(err))
                .finally(()=> window.hideLoading())
        },
    },  
    mounted() 
    {
        this.documentId
        this.onFormLoaded();
        this.getTransferFavorite();
        this.isUAEPassEnabledForTemplate = constants.isUAEPassEnabledTemplate ;
        this.isEsealEnabledForTemplate = constants.isEsealEnabledTemplate ;
        this.GetUserSignatures(this.documentId);
        this.enableUserMultipleSignatures = this.constants.enableUserMultipleSignatures;
        if(this.sign)
        {
            this.openDefaultSignerMethod();
            this.enableUserToSelectSigner = this.enableUserToSelectSigner;
            this.getUserApplicatinRole();
        }
        if(sessionStorage.getItem("userPinCode") != undefined && sessionStorage.getItem("userPinCode") != "null")
        {
            this.pinCode = this.decryptParam(sessionStorage.getItem("userPinCode"));
            // this.pinValidate = true;
        }
    },
    watch: 
    {
        purpose(newVal, oldVal) 
        {
            if (
                !this.hasPurposeWatched &&
                newVal != null &&
                newVal.id != 0 &&
                (newVal.name === '' || newVal.name == null)
            ) {
                var tempPurpose = this.purpose_items.filter(x => x.id == newVal.id);
                this.purpose = {id: tempPurpose[0].id, name: tempPurpose[0].name}
                this.hasPurposeWatched = true; // block future runs
            }
            else
            {
                this.hasPurposeWatched = false;
            }
        },
        sign() 
        {
            this.pinValidate = !this.sign
            // if (this.delegationId > 0)
            //     this.CheckSignatureImpersonation()
        },
        transferFormDialog(newVal, oldVal) 
        {
            if (newVal != oldVal) 
            {
                if (newVal == true)
                    this.onFormLoaded()
                else
                    this.clearForm()
            }
        },
        transferToMulti: {
            immediate: true,
            handler(val) {
                this.localTransferToMulti = val ? [...val] : [];
            }
        },
        transferCC: {
            immediate: true,
            handler(val) {
                this.localTransferCC = val ? [...val] : [];
            }
        },
        transferTo: {
            immediate: true,
            handler(val) {
                this.localTransferTo = val ? { ...val } : null;

                this.Forwarded = [];

                if (this.localTransferTo?.id != null) {
                    axios.get(
                        constants.baseApiUrl +
                        'Transfer/GetAutoForwardRules?ForwardTo=' +
                        this.localTransferTo.id +
                        '&isUser=' +
                        this.localTransferTo.isUser +
                        '&delegationId=' +
                        this.delegationId
                    )
                    .then(res => this.Forwarded = Array.isArray(res.data) ? res.data : [])
                    .catch(err => console.log(err));
                } else {
                    this.Forwarded = [];
                }

                if (this.transferId != null) {
                    axios.get(
                        constants.baseApiUrl +
                        'Transfer/GetNumberOfAttachmentsToUploadForMultiApproval?transferId=' +
                        this.transferId
                    )
                    .then(res => this.numberOfAttachmentsRemainingToUpload = res.data);
                }
            }
        },
        documentId:function(newValue,oldValue) {
            if (this.documentId > 0) {
                this.GetUserSignatures(this.documentId); 
            }
        },   
    },
    computed: {
        shouldShowAdvanceTransfer()
        {
            return (this.disableAdvancedTransferNew == false || this.disableAdvancedTransfersBeforeIsSigned == false) && !this.forwardCC && this.allowedAdvancedTransferFormTypes.includes(this.transferFormType)
        }

    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.radio-label { display: inline-block; margin-right: 10px; }
.radio-input { margin-right: 5px; }
.ad__box { margin-left: 9px; margin-right: 9px; padding-top: 6px; }
.ad__text { margin-bottom: 5px; }
.ad__text__bold { font-weight: bold; }
.ad__box p { margin-bottom: 0px; }
.multiselect__option--highlight .v-avatar { color: #205CDF !important;}
.multiselect__select { display: none !important; }
.green-border {
    border: 2px solid green;
    border-radius: 6px;
    padding: 8px;
}
</style>

</style>